/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from './View'
import { mono, boFont, boMedia } from '@components/systems/backoffice/backoffice.tokens'

interface PropsType {
	title?: string
	renderTitle?: React.ReactNode
	leftHeaderAccessory?: JSX.Element
	rightHeaderAccessory?: React.ReactNode
}

/**
 * 페이지 헤더 한 줄 — 제목(Thin 26) · 좌 도구 · 우 액션, 아래 헤어라인.
 * 모바일에서 우측 액션을 화면 우하단에 띄우던 것은 없앴다(흐름 안에 그대로 둔다).
 */
export const BoxHeaderView = (props: PropsType) => {
	const title: string = props.title !== undefined ? props.title : ''

	return (
		<View css={style} className="boBoxHeader">
			<View className="innerView">
				{props.renderTitle !== undefined ? (
					props.renderTitle
				) : (
					<h1 className="title">{title}</h1>
				)}
				{props.leftHeaderAccessory && (
					<View className="leftAccssory">{props.leftHeaderAccessory}</View>
				)}
				<View className="rightAccessory">{props.rightHeaderAccessory ?? null}</View>
			</View>
		</View>
	)
}

const style = css({
	position: 'relative',
	flexShrink: 0,
	textAlign: 'left',
	paddingTop: 24,
	paddingBottom: 16,
	borderBottom: `1px solid ${mono.line}`,
	fontFamily: boFont.ui,

	'.innerView': {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '12px 24px',
		minHeight: 34,

		'.title': {
			margin: 0,
			fontSize: 26,
			fontWeight: 300,
			lineHeight: 1.15,
			letterSpacing: '-0.01em',
			color: mono.ink,
			whiteSpace: 'nowrap',
		},

		'.leftAccssory': {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},

		'.rightAccessory': {
			display: 'flex',
			alignItems: 'center',
			gap: 8,
			marginLeft: 'auto',
		},
	},

	[boMedia.tablet]: {
		'.innerView': {
			'.title': { fontSize: 24 },
		},
	},
	// 폰·태블릿 — 제목 줄은 스크롤 위에 붙어 있는다 (2026-09-29 사용자 요청)
	[boMedia.notDesktop]: {
		position: 'sticky',
		top: 0,
		zIndex: 3,
		background: mono.bg,
	},
	[boMedia.phone]: {
		paddingTop: 12,
		paddingBottom: 10,
		'.innerView': {
			gap: '8px 12px',
			'.title': { fontSize: 22, whiteSpace: 'normal' },
			'.leftAccssory': { marginLeft: 'auto' },
			'.rightAccessory': {
				width: '100%',
				marginLeft: 0,
				flexWrap: 'wrap',
				'& .actionButtonWrap button, & .boBtn, & .boBtnGhost, & .boBtnText': {
					minHeight: 40,
				},
			},
			'.rightAccessory:empty': { display: 'none' },
		},
	},
})
